<template>
  <v-card-actions>
    <v-spacer />
    <v-btn
      v-if="cancelText"
      outlined
      @click="onCancelClick">
      {{ cancelText }}
    </v-btn>
    <v-btn
      v-if="submitText"
      class="white--text"
      color="blue"
      elevation="0"
      @click="onSubmitClick">
      {{ submitText }}
    </v-btn>
  </v-card-actions>
</template>
<script>
export default {
  name: 'ProjectDetailControlsViewActions',
  props: {
    cancelText: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: '',
    },
  },
  methods: {
    onCancelClick() {
      this.$emit('onCancelClick');
    },
    onSubmitClick() {
      this.$emit('onSubmitClick');
    },
  },
};
</script>
